var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.625 18C29.625 17.3787 29.1213 16.875 28.5 16.875H7.5C6.87869 16.875 6.375 17.3787 6.375 18C6.375 18.6213 6.87869 19.125 7.5 19.125H28.5C29.1213 19.125 29.625 18.6213 29.625 18Z",
    fill: "#22092C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.625 10.5C29.625 9.87868 29.1213 9.375 28.5 9.375H7.5C6.87869 9.375 6.375 9.87868 6.375 10.5C6.375 11.1213 6.87869 11.625 7.5 11.625H28.5C29.1213 11.625 29.625 11.1213 29.625 10.5Z",
    fill: "#22092C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.625 25.5C29.625 24.8787 29.1213 24.375 28.5 24.375H7.5C6.87869 24.375 6.375 24.8787 6.375 25.5C6.375 26.1213 6.87869 26.625 7.5 26.625H28.5C29.1213 26.625 29.625 26.1213 29.625 25.5Z",
    fill: "#22092C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.626be78ec0841c1947b2329d97fe0a4f.svg";
export { ForwardRef as ReactComponent };